import React from 'react';
import './BannerPromo.css'

const BannerPromo = props => {
  let display = props.display;
  if (!display) display = false;
  return (
    <div className="bannerSugere" style={{ display: display }} >
      <div className="content-sugere" style={{ display: display }}>
        <img src="assets/background.png" alt="banner" className="img-responsive" />
        {/* <div className="closeBanner" onClick={() => this.setState({ displayBanner: 'none', topBanner: 'none' })}>x</div> */}
        {/* <button className="btnAcceptPromo" onClick={props.handleAcceptPromo}>Eu Quero =)</button>
        <button className="btnDeclinePromo" onClick={props.handleNotAcceptPromo}>Não, obrigado</button> */}
        <div className="ui buttons btnPromo">
          <button className="ui positive button" onClick={props.handleAcceptPromo}>Eu quero :)</button>
          <div className="or" data-text="ou"></div>
          <button className="ui button" onClick={props.handleNotAcceptPromo}>Não, obrigado</button>
        </div>
      </div>

    </div>
  )

}

export default BannerPromo;